import { Button, Flex, Grid, GridItem } from "@chakra-ui/react";
import { Plus } from "lucide-react";
import { useAppContext } from "../../contexts/AppContext";
import ReportingKPIs from "./widgets/ReportingKPIs";
import RegulatoryTimelineWidget from "./widgets/RegulatoryTimelineWidget";
import ReportProgressWidget from "./widgets/ReportProgressWidget";

const ReportingOverview = ({ reportManager }) => {
  // Récupérer les données depuis le contexte
  const { data: funds } = useAppContext();

  return (
    <Flex direction="column" p={0} w="100%" gap={8}>
      {/* Header avec titre et bouton */}
      <Flex justifyContent="space-between" direction={{ lg: "row", base: "column" }} gap={4}>
        <h1>Reporting Overview</h1>
        <Button
          onClick={reportManager.openNewReportModal}
          w="fit-content"
          leftIcon={<Plus size={16} />}
        >
          New report
        </Button>
      </Flex>

      {/* Grille du dashboard */}
      <Grid
        templateColumns={{ base: "1fr", md: "1fr 1fr", lg: "repeat(3, 1fr)" }}
        gap={{ base: 8, md: 16 }}
      >
        <GridItem colSpan={{ base: 1, lg: 3 }}>
            <ReportingKPIs />
        </GridItem>

        {/* GridItem pour Suivi de Progression des Rapports */}
        <GridItem colSpan={{ base: 1, lg: 1 }}>
            <ReportProgressWidget funds={funds} />
        </GridItem>

        {/* GridItem pour les Échéances Réglementaires */}
        <GridItem colSpan={{ base: 1, lg: 2 }}>
            <RegulatoryTimelineWidget funds={funds} />
        </GridItem>

     
      </Grid>
    </Flex>
  );
};

export default ReportingOverview;
